import { ScheduleItem } from '@interfaces/schedule.interface'

export const getSchedules = [
  {
    username: '_wandersonsales_',
    squidId: '051f63162c7a',
    campaignId: '63a470fabe5791803cb228c4',
    socialNetwork: 'instagram',
    status: 'recruited',
    dates: [],
  },
] as unknown as ScheduleItem[]

export const campaignForPreApprovalContent = {
  campaign: {
    _id: '64807ee4ba29ffe157064bd2',
    status: 'in_progress',
    historyStatus: [
      {
        status: 'briefing',
        date: '2023-06-07T09:58:12.000Z',
      },
      {
        status: 'archived',
        date: '2023-06-20T10:57:20.000Z',
      },
      {
        status: 'briefing',
        date: '2023-06-20T10:57:22.000Z',
      },
      {
        status: 'recruitment',
        date: '2023-06-20T10:58:19.000Z',
      },
      {
        status: 'in_progress',
        date: '2023-07-18T22:57:34.000Z',
      },
      {
        status: 'finished',
        date: '2023-07-24T17:40:26.000Z',
      },
      {
        status: 'in_progress',
        date: '2023-07-24T17:40:41.000Z',
      },
    ],
    owner: {
      name: 'Amanda de Paula Moreira',
      sub: 'frJPs3vG3Fde0ov3v2xfE5tJlnx2',
      email: 'amanda.paula@squidit.com.br',
    },
    title: 'Squid',
    idPipefy: '730648821',
    exhibitionName: 'Campanha Squid Creators',
    customerName: 'Squid',
    socialNetworks: ['instagram'],
    organizations: {
      ids: ['56605cfad4c606c85eb10dd6'],
      name: 'Squid',
    },
    startDate: '2023-05-01T03:00:00.000Z',
    endDate: null,
    briefing: {
      product: 'Campanhas',
      brand: 'Squider',
      clientName: 'Amanda de Paula Moreira',
      email: 'amanda.paula@squidit.com.br',
      website: 'https://app.squidit.com.br/home',
      brandDescription: 'sss',
      productDescription: 'ddd',
      competitors: 'ddd',
      expectation: 'ss',
      hashtag: 'semgluten',
      instagram: 'menosfluten_maissaude',
      youtube: '',
      twitter: '',
      postSpecification: 'jnnjn',
      influencerRestrictions: 'jnj',
      campaignRunDate: '2023-06-07T00:00:00.000Z',
      campaignRunTime: '2',
      person: '',
      categories: [],
      profileSamples: '',
      influencerMinAge: 18,
      influencerMaxAge: 28,
      influencerGenders: [],
      influencerStates: [],
      audienceAgeRanges: [],
      audienceGenders: [],
      audienceStates: [],
      brandloverCities: [],
      brandloverClass: [],
    },
    calculateMetrics: '2023-08-10T21:11:07.945Z',
    planning: {
      solution: 'Squid Influencers',
      cardsPipefy: [
        {
          id: '438167145',
          name: 'Squid Testes',
        },
      ],
      campaignFormat: 'branding',
      campaignObjective: '',
      kpis: {
        reach: null,
        impression: null,
        engagement: null,
        click: null,
      },
      influencersTiers: [
        {
          tier: 'nanos',
          influencerAmount: 3,
          totalPayment: 15000,
          igtv: 0,
          posts: 3,
          stories: 0,
          reels: 0,
          inserts: 0,
          completedVideos: 0,
          tweets: 0,
          retweets: 0,
          interactions: 0,
          others: '',
        },
      ],
      hasContentApproval: true,
      hasSquidEngage: false,
      squidEngageTotalPayment: '',
      squidEngagePaymentResponsable: '',
      hasAdsImageUseAuthorization: false,
      adsImageUseAuthorizationMonths: 3,
      hasDigitalImageUseAuthorization: false,
      digitalImageUseAuthorizationMonths: 3,
      hasInfluencerKit: false,
      endDate: '2024-01-05T02:59:59.000Z',
      hasContentBoost: false,
      idSquidGo: '',
      kit: {
        handling: false,
        shipping: false,
        production: false,
      },
      skipSquidContentApprove: false,
      startDate: '2023-06-11T03:00:00.000Z',
    },
    activation: {
      hasGamification: true,
      adheringTerms: ['TESTE'],
      hasCommunicationRules: false,
      recruitmentCommunication: {
        hasCentralizedEmailAddress: false,
        hasCustomEmail: false,
      },
      description: 'uma campanha bem legaldddd',
      categories: [11],
      clientDescription: 'ksnjsnkslk',
      startDate: '2023-06-16T03:00:00.000Z',
      endDate: '2024-01-10T02:59:59.000Z',
      timezone: 'America/Sao_Paulo',
      monitoringTag: 'vidadesquider',
      brandId: '17841448597205356',
      brandLogo: true,
      brandUsername: 'vidadesquider',
      brandPicture: {
        url: 'squid-profile-pictures/17841448597205356.jpg',
        cdnUrl: 'https://storage.googleapis.com/',
      },
      logo: {
        url: 'squid-dev/56605cfad4c606c85eb10dd6/influencers-647e4c345acb9e3d63477fb7-WhatsApp%20Image%202023-06-05%20at%2012.29.53.jpeg',
        cdnUrl: 'https://storage.googleapis.com/',
      },
      payments: {
        money: '1',
      },
      postsCount: 1,
      storiesCount: 0,
      reelsCount: 0,
      videosCount: 0,
      tweetsCount: 0,
      tweetsRetweetsCount: 0,
      tweetsThreadCount: 0,
      contractedUsersCount: 10,
      suggestionRules: {
        cities: [],
        ufs: [],
        gender: [],
        categories: [],
        countries: [],
      },
      suggestion: false,
      suggestionVisible: false,
      suggestionRequirements: [],
      responsible: 'Amanda de Paula Moreira',
      responsibleContact: 'amanda.paula@squidit.com.br',
      responsibleId: 'frJPs3vG3Fde0ov3v2xfE5tJlnx2',
      responsibleOrganization: '56605cfad4c606c85eb10dd6',
      responsibleCommercial: 'Amanda de Paula Moreira',
      responsibleCommercialId: 'frJPs3vG3Fde0ov3v2xfE5tJlnx2',
      responsibleTeam: 'tecnology',
      trackLink: [
        {
          title: 'Teste youtube editado',
          parameters: [
            {
              name: 'utm_campaign',
              value: '[[CAMPAIGN_NAME]]',
            },
            {
              name: 'utm_source',
              value: '[[INFLUENCER_USERNAME]]',
            },
            {
              name: 'utm_term',
              value: '[[CAMPAIGN_ID]]',
            },
          ],
          shortened: false,
          url: 'https://google.com.br',
          status: 0,
          excluded: true,
          _id: '64bee1ed8797357cef643dd5',
        },
        {
          title: 'Teste geral link',
          parameters: [
            {
              name: 'utm_medium',
              value: '[[CAMPAIGN_ID]]',
            },
          ],
          shortened: false,
          url: 'https://youtube.com.br',
          status: 0,
          excluded: true,
          _id: '64bee46348ffb9721adef23f',
        },
        {
          title: 'Testeeeee 2',
          parameters: [
            {
              name: 'utm_source',
              value: '[[CAMPAIGN_ID]]',
            },
            {
              name: 'utm_medium',
              value: '[[INFLUENCER_USERNAME]]',
            },
            {
              name: 'utm_content',
              value: '[[CAMPAIGN_NAME]]',
            },
          ],
          shortened: false,
          url: 'https://youtube.com.br',
          status: 0,
          excluded: true,
          _id: '64beec8ebdd150fe918686ce',
        },
      ],
      disableRankingVisualization: false,
      hasTrackLink: true,
      hasGamificationExternal: '',
      contract: '',
      coverImage: {
        url: 'squid-dev/56605cfad4c606c85eb10dd6/influencers-64807ee4ba29ffe157064bd2-quadrado-preto.png',
        cdnUrl: 'https://storage.googleapis.com/',
      },
      hasContract: false,
      igtvCount: 0,
    },
    isDuplicateCampaign: true,
    campaignReference: {
      _id: ['647e4c345acb9e3d63477fb7'],
      title: '[TESTE] Onboarding - Gabriela Ferreira',
    },
    createdAt: '2023-06-07T12:58:12.463Z',
    calculateRankings: '2023-08-10T21:11:07.951Z',
    __v: 0,
    contract: '',
    startOfWeek: 'monday',
    tiebreakerCriteria: 'postQuantity',
    totalGroup: 0,
    weekRanking: false,
    hasContract: false,
    idWebapp: null,
  },
  users: [
    {
      status: 'recruited',
      hasSawWarn: false,
      hasSawSurvey: false,
      customPayment: false,
      idNetwork: '17841400894450374',
      squidId: '7b2f14011feb',
      socialNetwork: 'instagram',
      username: 'heloisagiradi',
      manualAdded: false,
    },
  ],
  fitRequirements: {
    fits: {
      fitProfile: [],
      fitNetwork: [],
      fitOther: [],
    },
    fit: 100,
  },
  hasVacancies: true,
} as any
